import { onMessageFromWebApp, sendMessageToWebApp } from "./webAppMessenger";
import {
  GET_TOKEN,
  REVOKE_TOKEN,
  NOTIFICATION_TAP,
  REQUEST_PERMISSION_TO_SEND_NOTIFICATIONS,
  UPDATE_DEVICE_NOTIFICATION_TOKEN,
  UPDATE_BADGE_COUNT
} from "./messageTypes";

const firebaseMessaging =
  window.cordova &&
  window.cordova.plugins &&
  window.cordova.plugins.firebase &&
  window.cordova.plugins.firebase.messaging;

if (firebaseMessaging) {
  onMessageFromWebApp(REQUEST_PERMISSION_TO_SEND_NOTIFICATIONS, async () => {
    await firebaseMessaging.requestPermission({ forceShow: true });
    const token = await firebaseMessaging.getToken();
    sendMessageToWebApp(UPDATE_DEVICE_NOTIFICATION_TOKEN, { token });
  });

  onMessageFromWebApp(GET_TOKEN, async () => {
    const token = await firebaseMessaging.getToken();
    sendMessageToWebApp(UPDATE_DEVICE_NOTIFICATION_TOKEN, { token });
  });

  onMessageFromWebApp(REVOKE_TOKEN, async () => {
    firebaseMessaging.revokeToken();
  });

  firebaseMessaging.onBackgroundMessage(
    notification => {
      if (notification.tap == true) {
        sendMessageToWebApp(NOTIFICATION_TAP, { notification });
      }
    },
    error => {
      console.error("Problem in notification handler:", error);
    }
  );

  onMessageFromWebApp(UPDATE_BADGE_COUNT, async ({ newBadgeCount }) => {
    firebaseMessaging.setBadge(newBadgeCount);
  });
}
